import { createContext, useContext } from 'react';
import type { SerializedMeterModel } from '@enmon/commons/lib/tools';

interface ModelDetailContextValue {
  modelId: number | undefined;
  model: SerializedMeterModel | undefined;
}

export const ModelDetailContext = createContext<ModelDetailContextValue | null>(null);

export const useModelDetailContext = (): ModelDetailContextValue => {
  const context = useContext(ModelDetailContext);

  if (!context) {
    throw new Error('useModelDetailContext must be used within a ModelDetailProvider');
  }

  return context;
};
